import {UiAction, UiActionTypes} from '../actions/uiActions';

const UI_DARK_MODE_KEY = "darkMode";
const UI_HIDE_INTERCOM_KEY = "hideIntercom";

const fromStrToBool = (val: string | null): boolean => {
  return val === 'true';
}

export const initialUiState: IUiState = {
  headerKind: 'default',
  headerProperties: {},
  backgroundKind: 'default',
  isDarkMode: fromStrToBool(window.localStorage.getItem(UI_DARK_MODE_KEY)),
  hideIntercom: fromStrToBool(window.localStorage.getItem(UI_HIDE_INTERCOM_KEY)),
  showSubscriptionDialog: false,
  // Report Trigger Dialog
  showTriggerDialog: false,
  triggerDialogType: null,
  triggerDialogData: null,
  // Connection Dialog (create)
  showConnectionDialog: false,
  // Integration Dialog (create)
  showIntegrationDialog: false,
  integrationDialogType: null,
  // Saved Block Dialog (create)
  showSavedBlockDialog: false,
  savedBlockDialogContentId: null,
}

export interface IUiState {
  headerKind: string;
  headerProperties: { [key: string]: string | boolean };
  backgroundKind: string;
  isDarkMode: boolean;
  hideIntercom: boolean;
  showSubscriptionDialog: boolean;
  // Report Trigger Dialog
  showTriggerDialog: boolean;
  triggerDialogType: string | null;
  triggerDialogData: any;
  // Connection Dialog (create)
  showConnectionDialog: boolean;
  // Integration Dialog (create)
  showIntegrationDialog: boolean;
  integrationDialogType: string | null;
  // Saved Block Dialog (create)
  showSavedBlockDialog: boolean;
  savedBlockDialogContentId: string | null;
}

export default function queriesReducer(state: IUiState = initialUiState, action: UiAction): IUiState {
  switch (action.type) {
    case UiActionTypes.SELECT_HEADER:
      return {
        ...state,
        headerKind: action.payload.header,
        headerProperties: state.headerProperties ? {
          ...state.headerProperties,
          ...action.payload.properties,
        } : action.payload.properties
      };

    case UiActionTypes.SELECT_HEADER_TITLE:
      return {
        ...state,
        headerProperties: state.headerProperties ? {
          ...state.headerProperties,
          ...action.payload
        } : {
          ...action.payload
        }
      };

    case UiActionTypes.RESET_HEADER:
      return {
        ...state,
        headerKind: 'default',
        headerProperties: {}
      };

    case UiActionTypes.SELECT_LEFT_PANEL_BACKGROUND:
      return {
        ...state,
        backgroundKind: action.payload.background
      };

    case UiActionTypes.RESET_LEFT_PANEL_BACKGROUND:
      return {
        ...state,
        backgroundKind: 'default'
      };

    case UiActionTypes.SET_IS_DARK_MODE:
      window.localStorage.setItem(UI_DARK_MODE_KEY, action.payload as any); // saved as 'true' or 'false' (str)
      return {
        ...state,
        isDarkMode: action.payload
      };

    case UiActionTypes.SET_HIDE_INTERCOM:
      window.localStorage.setItem(UI_HIDE_INTERCOM_KEY, action.payload as any); // saved as 'true' or 'false' (str)
      return {
        ...state,
        hideIntercom: action.payload
      };

    case UiActionTypes.SET_SHOW_SUBSCRIPTION_DIALOG:
      return {
        ...state,
        showSubscriptionDialog: action.payload
      };
    case UiActionTypes.TOGGLE_TRIGGER_DIALOG:
      return {
        ...state,
        showTriggerDialog: action.payload.show,
        triggerDialogType: action.payload.show ? action.payload.type : null,
        triggerDialogData: action.payload.show ? action.payload.data : null,
      }
    case UiActionTypes.TOGGLE_CONNECTION_DIALOG:
      return {
        ...state,
        showConnectionDialog: action.payload.show,
      }
    case UiActionTypes.TOGGLE_INTEGRATION_DIALOG:
      return {
        ...state,
        showIntegrationDialog: action.payload.show,
        integrationDialogType: action.payload.type,
      }
    case UiActionTypes.TOGGLE_SAVED_BLOCK_DIALOG:
      return {
        ...state,
        showSavedBlockDialog: action.payload.show,
        savedBlockDialogContentId: action.payload.contentId,
      }
    default:
      return state;
  }
}
